import { Stack } from '@mui/material'
import React from 'react'
import { categories } from '../utils/constants'


export default function Sidebar({selectedCategory, setselectedCategory}) {


  return (
    <Stack
      direction="row"
      sx={{
        overflowY: "auto",
        height: { sx: "auto", md: "95%" },
        flexDirection: { md: "column" },
      }}
    >
      {categories.map((category, i) => (
        <button
          className="category-btn"
          onClick={() => setselectedCategory(category.name)}
          style={{
            background: category.name === selectedCategory && "#fc1503",
            color: "White",
          }}
          key={category.name}
        >
          <span
            style={{
              color: category.name === selectedCategory ? "white" : "red",
              marginRight: "15px",
            }}
          >
            {category.icon}
          </span>
          <span
            style={{
              opacity: category.name === selectedCategory ? "1" : "0.8",
            }}
          >
            {category.name}
          </span>
        </button>
      ))}
    </Stack>
  );
}
